import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('../view/home.page')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js